import React from 'react';
import { Github, Instagram } from 'lucide-react';
import { siteData } from '../mock';

const iconMap = { Instagram, Github };

const SocialLinks = () => (
  <div className="fixed bottom-5 right-5 z-40 hidden flex-col gap-3 xl:flex">
    {siteData.socials.map((social) => {
      const Icon = iconMap[social.icon];
      return (
        <a key={social.name} href={social.url} target="_blank" rel="noopener noreferrer" className="social-button group border-white/10 bg-black/50 backdrop-blur-xl" aria-label={social.name}>
          <Icon size={18} className="transition-transform group-hover:scale-110" />
        </a>
      );
    })}
  </div>
);

export default SocialLinks;
